import { createSelector } from 'reselect'

export const getUi = state => state.uiVersion
export const getClient = state => state.clientVersion
export const getLauncher = state => state.launcherVersion

export const getVersions = createSelector(
    [getUi, getClient, getLauncher],
    (uiVersion, clientVersion, launcherVersion) => ({ uiVersion, clientVersion, launcherVersion }),
)



// WEBPACK FOOTER //
// ./src/features/LoadingBar/data/versions/selectors.js